import { useLocaleStore } from "@dealer-center/core-locale";
import styled from "styled-components";
import { useGetUser } from "@dealer-center/ddc-api-user-fetch";
const StyledUserName = styled.span`
  font-weight: bold;
`;
const StyledHeader = styled.header`
  padding-bottom: 4px;
  h4 {
    margin: 0;
  }
`;

export const AccountSearchViewHeader = () => {
  const getLocaleString = useLocaleStore(state => state.getLocaleString);
  const { data: userData } = useGetUser();
  return (
    <StyledHeader>
      <h4>
        {getLocaleString("WELCOME_HEADING")}
        {", "}
        <StyledUserName>{`${userData?.first} ${userData?.last}`}</StyledUserName>
      </h4>
    </StyledHeader>
  );
};
